import { render, staticRenderFns } from "./additional.items.vue?vue&type=template&id=45e4b3c6"
import script from "./additional.items.vue?vue&type=script&lang=js"
export * from "./additional.items.vue?vue&type=script&lang=js"
import style0 from "./additional.items.vue?vue&type=style&index=0&id=45e4b3c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports